"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeActionCreator = exports.checkLicenseValidity = void 0;
const checkLicenseValidity = (authResult) => {
    const license = authResult.license;
    const isTenantExpired = authResult.tenant?.status !== "ACTIVE" /* TenantStatus.ACTIVE */;
    return license?.endDate ? new Date().getTime() < new Date(license.endDate).getTime() && !isTenantExpired : false;
};
exports.checkLicenseValidity = checkLicenseValidity;
function makeActionCreator(type) {
    return (payload) => ({ type, payload });
}
exports.makeActionCreator = makeActionCreator;
